import NewTransfer from './NewTransfer';

export default NewTransfer;
